import type { Appointment } from '@medplum/fhirtypes';
import {
  appointmentExpectsZoomMeeting,
  appointmentHasZoomMeeting,
} from '@/lib/zoom/appointmentZoomMeeting';

export type ZoomMeetingWaitState = 'idle' | 'waiting' | 'ready' | 'timed_out' | 'not_expected';

/**
 * Derive the next Zoom setup wait state from a freshly loaded Appointment.
 * Once timed out, stay timed out until the caller explicitly restarts (checkAgain).
 */
export function resolveZoomMeetingWaitState(
  appointment: Appointment | undefined,
  previous: ZoomMeetingWaitState,
): ZoomMeetingWaitState {
  if (!appointment) {
    return previous === 'idle' ? 'idle' : previous;
  }
  if (appointmentHasZoomMeeting(appointment)) {
    return 'ready';
  }
  if (!appointmentExpectsZoomMeeting(appointment)) {
    return 'not_expected';
  }
  if (previous === 'timed_out') {
    return 'timed_out';
  }
  return 'waiting';
}

export function isZoomMeetingWaitExpired(startedAtMs: number, nowMs: number, maxWaitMs: number): boolean {
  return nowMs - startedAtMs >= maxWaitMs;
}
